import { useAtomValue } from "jotai";
import { useRemindersRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { NotificationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { rightsState } from "web_myplann/Shared/State/rightsAtom";

const REMINDER_EXCLUDED_TYPES = [NotificationTypeEnum.ReminderTerm];

export const useNotificationExcludedTypes = (): {
	excludedTypes: NotificationTypeEnum[] | undefined;
	isReady: boolean;
} => {
	const hasRemindersRight = useRemindersRightOptional();
	const isPending = useAtomValue(rightsState) === undefined;

	return {
		excludedTypes: hasRemindersRight ? undefined : REMINDER_EXCLUDED_TYPES,
		isReady: !isPending,
	};
};
